import React from "react";
import { selectAuth } from "../../store/auth/selectors";
import { IApplicationState } from "../../store";
import { connect } from "react-redux";
import { IMenuItem } from "../../models/IMenuItem";
import FormSelect from "../forms/FormSelect";
import loadIntegrationOptions from "../../functions/loadIntegrationOptions";
import { IFormError } from "../forms/FormErrors";
import IAPI from "../../models/IAPI";
import { useIntegrationContext } from "./contexts/IntegrationContext";

export interface ISystemSelectProps<K> {
  token: string;
  id?: number;
  readonly?: boolean;
  onValueChange?: (val: IMenuItem | null) => void;
  required?: boolean;
  error?: IFormError;
  apis: IAPI[];
}

function SystemSelect<TForm>(props: ISystemSelectProps<TForm>) {
  const { token, id, readonly, onValueChange, apis, required, error } = props;
  const [items, setItems] = React.useState<IMenuItem[]>([]);
  const [item, setItem] = React.useState<IMenuItem | undefined | null>(null);

  const { setShowRemoveAPIsDialog } = useIntegrationContext();

  React.useEffect(() => {
    loadIntegrationOptions(token, id, setItems, setItem, opts => opts.Systems);
  }, [token, id]);

  const onValChange = (val: IMenuItem | null) => {
    if (apis && apis.length > 0) {
      setItem(val);
      setShowRemoveAPIsDialog(true);
      if (onValueChange) {
        onValueChange(val);
      }
    } else {
      if (onValueChange) {
        onValueChange(val);
      }
    }
  };

  return (
    <FormSelect
      name="System.ID"
      label="System"
      prompt="Select System"
      options={items}
      option={item}
      readonly={readonly}
      onValueChange={onValChange}
      required={required}
      error={error}
    />
  );
}

export default connect((state: IApplicationState) => ({
  ...selectAuth(state),
}))(SystemSelect);
